import React, {useMemo} from 'react'
import moment from 'moment'

const TimeColumn = () => {
  const CTimesOfDay = useMemo(() => {
    const increment = 60
    return Array.from({length: 24}).map((e, i) => {
      const date = moment().startOf('day')
      return (
        <div key={i} className="time-label">
          <span>{date.add(i * increment, 'minutes').format('h a')}</span>
        </div>
      )
    })
  }, [])
  return <div className="time-column">{CTimesOfDay}</div>
}

export default TimeColumn
